export const PERSIST_SET = 'PERSIST_SET'
//
export function store(key, value) {
  return {
    type: PERSIST_SET,
    key:key,
    value:value
  }
}



// WEBPACK FOOTER //
// ./src/actions/persist.js